import React from 'react';
import { Link } from 'react-router';
import {  Input,  DropDown } from 'components/tt-forms/common';
import { Dialog } from "@blueprintjs/core";
import DataTable from 'components/data-table';
import { header } from 'constants/table';
import { Danhmuc, ThanhTra } from 'api';
import { RowItemDanhSachThemMoiThanhTra } from 'modules/thanh-tra/datatable';
import { RowItemKetQuaTimKiemThanhTra, DataTableMultipleSelect } from 'modules/thanh-tra/datatable';

class ThemMoiDoiTuongThanhTra extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isOpen: false,

      linhVucList: [],
      linhVucId: '',
      tuKhoa: '',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      ketQuaTimKiemList: [],
      tableLoading: false,
      doiTuongSelectedList: [],
      checkAll: false,
      idSelectedList: [],
      totalSelectedList: [],
      doiTuongTrungList: [],
      popupTrung: false
    }
  }

  componentDidMount() {
    this.getLinhVuc();
  }

  getLinhVuc() {
    let state = this.state;
    Danhmuc.actions.getLinhVucDoiTuongThanhTra.request().then(res => {
      if (res.data && res.data._embedded) {
        state.linhVucList = res.data._embedded.linhVucDoiTuongThanhTras;
      } else {
        state.linhVucList = [];
      }
      this.setState(state);
    })
  }

  timKiem() {
    let params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: 'ngaySua,desc'
    }
    if (this.state.tuKhoa) {
      params.tuKhoa = this.state.tuKhoa;
    }
    if (this.state.linhVucId) {
      params.linhVucId = this.state.linhVucId;
    }
    let idList = [];
    this.props.importData.map(item => {
      if (item.doiTuongThanhTraInfo) {
        idList.push(item.doiTuongThanhTraInfo.doiTuongThanhTraId);
      }
    });
    this.state.doiTuongSelectedList.map(item => {
      idList.push(item.doiTuongThanhTraId);
    });
    if (idList.length) {
      params.doiTuongIds = idList.join();
    }
    Danhmuc.actions.getDoiTuongThanhTra.request(null, params).then(res => {
      if (res.data._embedded) {
        this.setState({
          ketQuaTimKiemList: res.data._embedded.doiTuongThanhTras,
          pageData: res.data.page,
          tableLoading: false
        });
      } else {
        this.setState({
          ketQuaTimKiemList: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading: false
        });
      }
    });
  }
  closeDialog(name) {
    this.setState({
      [name]: false
    }, () => {
      if (name === 'popupTrung') {
        document.body.className += ' pt-overlay-open';
      }
    });
  }

  openDialog() {
    this.timKiem();
    this.setState({
      isOpen: true
    });
  }

  onChange(name, e) {
    this.props.validators['thanhTra'] = [];
    this.setState({
      [name]: e.target.value
    })
  }

  checkValidate(){
    let pass = true;
    this.props.validators['thanhTra'].map(validator => {
      if (pass)
        pass = validator.validate();
      else
        validator.validate();
    });
    return pass;
  }

  handleChangePageSize(size) {
    this.setState({
      pageData: {
        ...this.state.pageData,
        size: size,
        number : 0
      }
    }, () => {
      this.timKiem();
    });
  }
  handlePageClick(page) {
    this.setState({
      pageData: {
        ...this.state.pageData,
        number : page.selected
      }
    }, () => {
      this.timKiem();
    });
  }

  hanldeRemove(index) {
    this.setState({doiTuongSelectedList: [...this.state.doiTuongSelectedList.splice(index, 1)]}, () => {
      this.timKiem();
    });
  }

  handleSave() {
    this.props.exportData(this.state.doiTuongSelectedList);
    this.setState({
      isOpen: false,
      linhVucId: '',
      tuKhoa: '',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      ketQuaTimKiemList: [],
      tableLoading: false,
      doiTuongSelectedList: [],
      checkAll: false,
      idSelectedList: [],
      totalSelectedList: []
    })
  }
  handleSelectedDoiTuong(item) {
    item.selected = !item.selected;
    if (item.selected) {
      this.state.idSelectedList.push(item.doiTuongThanhTraId);
      this.state.totalSelectedList.push(item);
    } else {
      this.state.idSelectedList.splice(this.state.idSelectedList.indexOf(item.doiTuongThanhTraId), 1);
      this.state.totalSelectedList.map((value, index) => {
        if (value.doiTuongThanhTraId == item.doiTuongThanhTraId) {
          this.state.totalSelectedList.splice(index, 1);
        }
      });
    }
    this.setState({...this.state});
  }

  handleSelectedAll() {
    let newState = {...this.state};
    newState.checkAll = !newState.checkAll;
    newState.ketQuaTimKiemList.map((item) => {
      item.selected = newState.checkAll;
      if (newState.checkAll) {
        if (newState.idSelectedList.indexOf(item.doiTuongThanhTraId) == -1) {
          newState.idSelectedList.push(item.doiTuongThanhTraId);
          newState.totalSelectedList.push(item);
        }
      } else {
        newState.idSelectedList = [];
        newState.totalSelectedList = [];
      }
    });

    this.setState({...newState});
  }

  themVaoCuocTT() {
    let newState = {...this.state};
    newState.doiTuongTrungList = [];
    newState.totalSelectedList.map(item => {
      newState.doiTuongSelectedList.push(item);
    });
    newState.totalSelectedList = [];
    newState.idSelectedList = [];

    newState.doiTuongSelectedList.map((item, index) => {
      let params = {
        doiTuongThanhTraId: item.doiTuongThanhTraId,
        namThanhTra: this.props.namThanhTra
      }
      ThanhTra.actions.getKiemTraDoiTuongTT.request(null, params).then(res => {
        if (res.data && res.data._embedded) {
          let itemData = {
            tenDoiTuong: item.ten,
            coQuanList: res.data._embedded.coQuanQuanLies
          }
          newState.doiTuongTrungList.push(itemData);
        }
        if (index == newState.doiTuongSelectedList.length-1 && newState.doiTuongTrungList.length) {
          newState.popupTrung = true;
        }
      });
    });
    this.setState({...newState});
    this.timKiem();
  }

  render() {
    return (
      <div className='reception-container'>
        <Link className="btn-green btn-pullright" onClick={this.openDialog.bind(this)}><i className="tt tt-addfile"></i>Thêm mới cuộc thanh tra</Link>
        <Dialog
          isOpen={this.state.isOpen}
          onClose={this.closeDialog.bind(this, 'isOpen')}
          title='Thêm mới cuộc thanh tra'
          className="dialog-them-moi-dttt dialog-default wrap-block"
        >
          <div className='row pl30 pr30'>
            <div className='col-100'>
              <h2 className='title-14 pt20 pb15'>1. Tìm kiếm đối tượng thanh tra</h2>
            </div>
            <Input className='col-60' label='Đối tượng' value={this.state.tuKhoa} onChange={this.onChange.bind(this, 'tuKhoa')} name='tuKhoa' placeholder='Nhập tên đối tượng...'/>
            <DropDown className='col-25' label='Ngành/Lĩnh vực' selectedValue={this.state.linhVucId} onChange={this.onChange.bind(this, 'linhVucId')} name='linhVucId' placeholder
              options={this.state.linhVucList} keyName="linhVucDoiTuongThanhTraId" valueName="ten"/>

            <div className='col-15 mt22'>
              <Link className='btn-green ml10' onClick={this.timKiem.bind(this)}>
                <i className='tt-search'></i>Tìm kiếm
              </Link>
            </div>
          </div>

          <div className='row pl10 pr10 '>
            <div className='col-100'>
              <h2 className='title-14 pt15 pb15 pr20 pl20'>1.1 Kết quả tìm kiếm</h2>
            </div>
            <div className='pl5 pr5'>
              <DataTableMultipleSelect onCheck={this.handleSelectedAll.bind(this)} selectAllStatus={this.state.checkAll} header={ header.thanhTra.KQTKTMDTTT } dataList={ this.state.ketQuaTimKiemList } tableLoading={ this.state.tableLoading } pageData={ this.state.pageData } parent={ this }>
                <RowItemKetQuaTimKiemThanhTra/>
              </DataTableMultipleSelect>
            </div>
            <div className='col-100 pb20 pt10 txt-center'>
              <Link className="btn-green" onClick={this.themVaoCuocTT.bind(this)}>
                <i className="tt tt-addfile"></i>Thêm vào cuộc thanh tra
              </Link>
            </div>
          </div>
          <div className='row pl10 pr10 '>
            <div className='row pl40 pr40'>
              <span className='line-border mt5 mb0'></span>
            </div>
            <div className='col-100'>
              <h2 className='title-14 pt15 pb15 pr20 pl20'>1.2 Danh sách đối tượng sẽ được thêm vào thanh tra</h2>
            </div>
            <div className='pl5 pr5'>
              <DataTable header={ header.thanhTra.TMDTTT } dataList={ this.state.doiTuongSelectedList } hideButtonExport={true} hidePagination={ true } parent={ this }>
                <RowItemDanhSachThemMoiThanhTra />
              </DataTable>
            </div>
          </div>
          <div className='row pl15 pr15'>
            <span className='line-border mt5 mb0'></span>
          </div>
          <div className="action-form-wrap pt20">
            <div className="box-bottom">
              <Link className="btn-action btn-close" onClick={this.closeDialog.bind(this, 'isOpen')}><span>Đóng</span></Link>
              <Link className="btn-action btn-save" onClick={this.handleSave.bind(this)}><span>Lưu</span></Link>
            </div>
          </div>
        </Dialog>
        <Dialog
          isOpen={this.state.popupTrung}
          onClose={this.closeDialog.bind(this, 'popupTrung')}
          title='Thông báo'
          className="dialog-default wrap-block medium"
        >
          <div className='row pl30 pr30 pt20'>
            {
              this.state.doiTuongTrungList.map((item,i) => (
                <ul key={i}>
                  <li className="title-text pb14">Đối tượng "{item.tenDoiTuong}" đã thuộc kế hoạch/ cuộc thanh tra của các đơn vị sau:</li>
                  {
                    item.coQuanList.map((coQuanItem, index) => (
                      <li className="content-text bt pt14 pb14" key={index}>{index+1}. {coQuanItem.ten}</li>
                    ))
                  }
                </ul>
              ))
            }
          </div>
          <div className='row pl15 pr15'>
            <span className='line-border mt5 mb0'></span>
          </div>
          <div className="action-form-wrap pt20">
            <div className="box-bottom">
              <Link className="btn-action btn-close" onClick={this.closeDialog.bind(this, 'popupTrung')}><span>Đóng</span></Link>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

ThemMoiDoiTuongThanhTra.defaultProps = {
  validators: []
}

export default ThemMoiDoiTuongThanhTra;


// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-thuc-hien/sub-view/ThemMoiDoiTuongThanhTra.jsx